import { render, staticRenderFns } from "./express_detail.vue?vue&type=template&id=7b7d2e06&scoped=true"
import script from "./express_detail.vue?vue&type=script&lang=js"
export * from "./express_detail.vue?vue&type=script&lang=js"
import style0 from "./express_detail.vue?vue&type=style&index=0&id=7b7d2e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7d2e06",
  null
  
)

export default component.exports